import { RootState } from '@/redux-store';

export const selectPayoutSetting = (state: RootState) => state.reducer.payrollSettings.payoutSetting;
